import React, { useState } from 'react';
import './KlachtenregelingPage.css';

function SecondPage() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [rideDate, setRideDate] = useState('');
    const [licensePlate, setLicensePlate] = useState('');
    const [complaint, setComplaint] = useState('');

    const handleSubmit = async (event) => {
        event.preventDefault();

        const formData = {
            name,
            email,
            phone,
            rideDate,
            licensePlate,
            complaint,
            senderEmail: email 
        };

        try {
            const response = await fetch('http://localhost:5000/api/Complaints/SendComplaintEmail', { // Assuming you have a server endpoint
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });

            if (response.ok) {
                alert('Klacht is succesvol verzonden!');
            } else {
                // Get the status code and status text
                const statusCode = response.status;
                const statusText = response.statusText;

                // Try to read the response body as JSON
                try {
                    const errorData = await response.json();
                    console.error('API Error (JSON):', statusCode, statusText, errorData);
                    alert(`Er is een fout opgetreden bij het verzenden van de klacht. Response NOK: ${statusCode} ${statusText}. Zie console voor details.`);
                } catch (jsonError) {
                    // If JSON parsing fails, try to read the response body as text
                    try {
                        const errorText = await response.text();
                        console.error('API Error (Text):', statusCode, statusText, errorText);
                        alert(`Er is een fout opgetreden bij het verzenden van de klacht. Response NOK: ${statusCode} ${statusText} ${errorText}. Zie console voor details.`);
                    } catch (textError) {
                        // If reading as text also fails, show a generic error
                        console.error('API Error (Generic):', statusCode, statusText);
                        alert(`Er is een fout opgetreden bij het verzenden van de klacht en kan foutmelding niet uitlezen. Response NOK: ${statusCode} ${statusText}.`);
                    }
                }
            }
        } catch (error) {
            console.error('Fetch Error:', error);
            alert('Er is een fout opgetreden bij het verzenden van de klacht.'+ error);
        }
    };

    return (
        <div className="complaints-page">
            <header>
                <h1>Klachtenformulier</h1>
            </header>

            <section className="complaints-content">
                <p>
                    Heeft u een klacht over een taxirit? Vul dan onderstaand formulier zo volledig mogelijk in.
                    Wij nemen uw klacht serieus en zullen ons best doen om tot een passende oplossing te komen.
                </p>

                <form className="complaints-form" onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label htmlFor="name">Naam:</label>
                        <input type="text" id="name" name="name" value={name} onChange={(e) => setName(e.target.value)} required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="email">E-mailadres:</label>
                        <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="phone">Telefoonnummer:</label>
                        <input type="tel" id="phone" name="phone" value={phone} onChange={(e) => setPhone(e.target.value)} required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="rideDate">Datum taxirit:</label>
                        <input type="date" id="rideDate" name="rideDate" value={rideDate} onChange={(e) => setRideDate(e.target.value)} required />
                    </div>

                    <div className="form-group">
                        <label htmlFor="licensePlate">Kenteken taxi:</label>
                        <input type="text" id="licensePlate" name="licensePlate" value={licensePlate} onChange={(e) => setLicensePlate(e.target.value)} />
                    </div>

                    <div className="form-group">
                        <label htmlFor="complaint">Omschrijving klacht:</label>
                        <textarea id="complaint" name="complaint" rows="4" value={complaint} onChange={(e) => setComplaint(e.target.value)} required></textarea>
                    </div>

                    <button type="submit">Versturen</button>
                </form>
            </section>
        </div>
    );
}

export default SecondPage;